// Request parameters.
export const ANOMALIES_LIMIT = 6;
export const ANOMALIES_ORDER_BY = "detect_date_time.desc";
